import { render, staticRenderFns } from "./echart.vue?vue&type=template&id=616ddc9c&scoped=true"
import script from "./echart.vue?vue&type=script&lang=js"
export * from "./echart.vue?vue&type=script&lang=js"
import style0 from "./echart.vue?vue&type=style&index=0&id=616ddc9c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616ddc9c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('616ddc9c')) {
      api.createRecord('616ddc9c', component.options)
    } else {
      api.reload('616ddc9c', component.options)
    }
    module.hot.accept("./echart.vue?vue&type=template&id=616ddc9c&scoped=true", function () {
      api.rerender('616ddc9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/RMC/Protein/rmcDrugDosage/echart.vue"
export default component.exports